import React, { Component, Fragment } from 'react'
import PropTypes from "prop-types"

class GeneralInfo extends Component {
  static propTypes = {
    data: PropTypes.object,
    claim_id: PropTypes.string
  }
  
  static defaultProps = {
    data: {},
    claim_id: ''
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {}
  
  handleChangeInput = async (e) => {
    let value = e.target.value
    let name = e.target.name
    this.setState({[name]: value})
  }

  render() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-light font-size-title font-weight-bold">
                <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#collapse-general-info" role="button" aria-expanded="false" aria-controls="collapse-general-info">General Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
              </div>
              <div className="collapse" id="collapse-general-info">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Claim Number</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_claim_number" placeholder="Claim Number" value={this.props.data.general_claim_number} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">SKP Number</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_skp_number" placeholder="SKP Number" value={this.props.data.general_skp_number} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Program Number</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_program_number" placeholder="Program Number" value={this.props.data.general_program_number} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal</label>
                        <div className="col-sm-8"> 
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_principal" placeholder="Principal" value={this.props.data.general_principal} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Reff Number / SKP</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_reff_number" placeholder="Reff Number" value={this.props.data.general_reff_number} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Program Type</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_program_type" placeholder="Program Type" value={this.props.data.general_program_type} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" > Program Descriptions </label> 
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_description" placeholder="Program Description" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_description} />
                        </div>
                      </div>
                      <div className="form-group row"> 
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" > Program Submitted Date </label>
                        <div className="col-sm-8"> 
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="general_program_submitted_date" value={this.props.data.general_program_submitted_date} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" > Start Date </label>
                        <div className="col-sm-3"> 
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="general_program_start_date" value={this.props.data.general_program_start_date} />
                        </div>
                        <label htmlFor="inputEmail3" className="col-sm-2 col-form-label" > End Date </label>
                        <div className="col-sm-3"> 
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="general_program_end_date" value={this.props.data.general_program_end_date} />
                        </div>
                      </div>
                      <div className="form-group row"> 
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" > Claim Exp Date </label>
                        <div className="col-sm-8"> 
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="general_claim_exp_date" value={this.props.data.general_claim_exp_date} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Budget Type</label>
                        <div className="col-sm-8">
                          <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="general_budget_type" placeholder="Budget Type" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_budget_type} /> 
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Budget </label>
                        <div className="col-sm-8">
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" placeholder="Budget" name="general_budget" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_budget ? this.props.data.general_budget.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, } ) : ''} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Budget Assigned</label>
                        <div className="col-sm-8">
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" placeholder="Budget Assigned" name="general_budget_assigned" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_budget_assigned ? this.props.data.general_budget_assigned.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, } ) : ''} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"> Sales Target </label>
                        <div className="col-sm-8">
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" placeholder="Sales Target" name="general_sales_target" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_sales_target.toLocaleString( "en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, })} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Customer PPh Type</label>
                        <div className="col-sm-8">
                          <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="general_customer_pph_type" value={this.props.data.general_customer_pph_type} />
                        </div> 
                      </div>
                      <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PPh Rate (%)</label>
                        <div className="col-sm-8">
                          <input disabled type="number" max="100" min="0" autoComplete="off" className="form-control" id="inputEmail3" placeholder="PPh Rate" name="general_customer_pph_rate" onChange={this.handleChangeInput.bind(this)} value={this.props.data.general_customer_pph_rate} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default GeneralInfo